(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component.gift-tip-form"] && !Shopify.designMode) return;
  try {
    class GiftTip {
    constructor(target) {
      this.target = target;
      this.form = this.target.querySelector('form');
      this.form_validation;

      this.setEvents();
      this._setInputValidation();
      this.init();
    }
    async _validateForm(customerEmail, customerFirstName, customerLastName) {
      let formIsValid = await this.form_validation.revalidate();
      return formIsValid;
    }
    _updatePlaceholders() {
      const inputs = this.form.querySelectorAll('input[name]');

      inputs.forEach((input) => {
        const name = input.getAttribute('name');

        input.addEventListener('input', () => {
          const placeholders = this.target.querySelectorAll(`.gift-tip--placeholder[data-value="${name}"]`);
          placeholders.forEach((placeholder) => {
            placeholder.textContent = input.value;
          });
        });

        // Trigger initial update
        const placeholders = this.target.querySelectorAll(`.gift-tip--placeholder[data-value="${name}"]`);
        placeholders.forEach((placeholder) => {
          placeholder.textContent = input.value;
        });
      });
    }

    _setInputValidation() {
      const validation = new window.JustValidate(this.form, {
        validateBeforeSubmitting: true,
        focusInvalidField: true,
        successLabelCssClass: ['Form__Input--valid'],
        successFieldCssClass: ['Form__Input--valid'],
        errorLabelCssClass: ['Form__Input--invalid'],
        errorFieldCssClass: ['Form__Input--invalid'],
        successFieldGroupCssClass: ['Form__Item--invalid'],
        errorFieldGroupCssClass: ['Form__Item--invalid'],
      });

      const senderFullName = this.form.querySelector('[name="sender[full_name]"]');
      const senderEmail = this.form.querySelector('[name="sender[email]"]');
      const recipientFullName = this.form.querySelector('[name="recipient[full_name]"]');
      const recipientEmail = this.form.querySelector('[name="recipient[email]"]');

      validation
        .addField(senderFullName, [
          {
            rule: 'required',
            errorMessage: 'Digite seu nome',
          },
          {
            validator: (value) => {
              return value.split(' ').length >= 2;
            },
            errorMessage: 'Digite Nome e sobrenome',
          },
        ])
        .addField(senderEmail, [
          {
            rule: 'required',
            errorMessage: 'Digite seu email',
          },
          {
            rule: 'email',
            errorMessage: 'Digite um email válido',
          },
        ])
        .addField(recipientFullName, [
          {
            rule: 'required',
            errorMessage: 'Digite o nome de quem vai receber',
          },
          {
            validator: (value) => {
              return value.split(' ').length >= 2;
            },
            errorMessage: 'Digite Nome e sobrenome',
          },
        ])
        .addField(recipientEmail, [
          {
            rule: 'required',
            errorMessage: 'Digite o email de quem vai receber',
          },
          {
            rule: 'email',
            errorMessage: 'Digite um email válido',
          },
        ]);

      this.form_validation = validation;
    }
    async sendGiftTip() {
      try {
        const formData = Object.fromEntries(new FormData(this.form).entries());

        const body = {
          sender: {
            first_name: formData['sender[full_name]'].split(' ').shift(),
            last_name: formData['sender[full_name]'],
            email: formData['sender[email]'],
          },
          recipient: {
            first_name: formData['recipient[full_name]'].split(' ').shift(),
            last_name: formData['recipient[full_name]'],
            email: formData['recipient[email]'],
          },
          product: {
            id: formData['product[id]'],
            title: formData['product[title]'],
            handle: formData['product[handle]'],
          },
        };
        await axios.post('https://hooks.zapier.com/hooks/catch/23122411/2v4tlud/', JSON.stringify(body));
        alert('Sua dica de presente foi enviada, torcemos para que você e seu produto favorito dêem o match perfeito');
      } catch (error) {
        alert('Não foi possível enviar sua dica de presente, tente novamente mais tarde');
      }
    }
    setEvents() {
      let submitBtnList = this.form.querySelectorAll('[type="submit"]');

      for (const submitBtn of submitBtnList) {
        submitBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.target.classList.add('--loading');
          try {
            const formIsValid = await this._validateForm();
            if (formIsValid) {
              this.sendGiftTip();
            }
          } catch (error) {
            console.error('Error fetching customer status:', error);
          }
          e.target.classList.remove('--loading');
        });
      }
    }
    init() {
      this._updatePlaceholders();
    }
  }

  document.addEventListener('DOMContentLoaded', async function () {
    new GiftTip(document.querySelector('.gift-tip--wrapper'));
  });
  } catch(e) { console.error(e); }
})();

})();
